import { render, staticRenderFns } from "./telegram-route-ticket.vue?vue&type=template&id=d9b10fda&scoped=true&"
import script from "./telegram-route-ticket.vue?vue&type=script&lang=js&"
export * from "./telegram-route-ticket.vue?vue&type=script&lang=js&"
import style0 from "./telegram-route-ticket.vue?vue&type=style&index=0&id=d9b10fda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b10fda",
  null
  
)

export default component.exports